// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3f7yU","footer":"ModalUpdate_footer__3lTK9"};